import { SecurityMessage } from '@treasury/domain/channel/mappings/security';
import { IdentityDialogResult, TmApiError } from '@treasury/domain/shared';
import { nothing, TemplateResult } from 'lit';

/**
 * The high-level contract identity verification dialog components must implement.
 */
export interface IdentityDialogContext {
    readonly verifying: boolean;
    securityMessage: SecurityMessage;
    disableClose: boolean;
    verify(): Promise<boolean>;
    reverify(message: SecurityMessage): Promise<void>;
    requestUpdate(): void;
    cancel(): void;
}

export interface AccountValidationResult {
    success: boolean;
    result?: SecurityMessage;
}

export enum IdentityDialogEvent {
    Close = 'close',
}

export type IdentityDialogResultInternal = Omit<IdentityDialogResult, 'reason'> | TmApiError;

/**
 * Defines a contract for rendering and MFA logic in an `IdentityVerificationDialog` instance.
 */
export interface IdentityDialogStrategy {
    password?: string;
    renderContent(): TemplateResult | typeof nothing;
    renderActions(): TemplateResult | typeof nothing;
    validateAccountPassword(password: string): Promise<AccountValidationResult>;
}

export const NullIdentityStrategy: IdentityDialogStrategy = {
    renderContent: () => nothing,
    renderActions: () => nothing,
    validateAccountPassword: async () => ({
        success: true,
    }),
};
